<nav class="navbar navbar-expand-lg navbar-light fixed-top">
    <a class="navbar-brand" routerLink="">
        <img src="../../../assets/logo.png" class="logoSodimac">
        <span class="pgs">
            PGS
        </span>
    </a>
    <button class="navbar-toggler" type="button" aria-controls="navbarSupportedContent" [attr.aria-expanded]="!isCollapsed"
        aria-label="Toggle navigation" (click)="isCollapsed = !isCollapsed">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent" [ngbCollapse]="isCollapsed">
        <ul class="navbar-nav">
            <ng-container *ngFor="let item of items">
                <li *ngIf="item.show && !item.subitems" class="nav-item">
                    <a class="nav-link" [class.disable]="isCurrRoute(item.route)" [routerLink]="item.route" [routerLinkActive]="activeClass">{{item.name}}</a>
                </li>
                <li *ngIf="item.show && item.subitems" class="nav-item" ngbDropdown>
                    <a class="nav-link pointer" ngbDropdownToggle>{{item.name}}</a>
                    <div ngbDropdownMenu>
                        <ng-container *ngFor="let subitem of item.subitems">
                            <a *ngIf="subitem.show" [class.disable]="isCurrRoute(subitem.route)" [routerLink]="subitem.route" [queryParams]="subitem.queryParams"
                                [routerLinkActive]="activeClass" class="dropdown-item">{{subitem.name}}</a>

                        </ng-container>
                    </div>
                </li>
            </ng-container>
            <li *ngIf="isAuthenticated && stores && stores.length > 1" class="nav-item ml-auto">
                <a class="nav-link pointer dropdown-toggle" id="navbarDropdownMenuStore" (click)="showStoresModal()">
                    <i class="fas fa-home pr-1"></i>
                    <span class="d-lg-none d-xl-inline-block">{{currStore?.identificationNumber}} - {{currStore?.name}}</span>
                    <span class="d-xl-none">{{currStore?.identificationNumber}}</span>
                </a>
            </li>
            <li *ngIf="isAuthenticated && stores && stores.length === 1" class="nav-item ml-auto">
                <a class="nav-link">
                    <span class="d-lg-none d-xl-inline-block">{{currStore?.identificationNumber}} - {{currStore?.name}}</span>
                    <span class="d-xl-none">{{currStore?.identificationNumber}}</span>
                </a>
            </li>
            <li *ngIf="isAuthenticated && tenants && tenants.length > 1" ngbDropdown placement="bottom-right" class="nav-item" [class.ml-auto]="!stores || stores.length === 0">
                <a ngbDropdownToggle class="nav-link pointer" id="navbarDropdownMenuTenant">
                    <img src="http://www.geonames.org/flags/s/{{selectedTenant.shortLabel}}.png" class="pr-1"> {{selectedTenant.label}}
                </a>
                <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                    <a (click)="changeTenant(country)" id="country.shortLabel" *ngFor="let country of tenants" class="dropdown-item" [routerLink]="[]" [class.d-none]="country.shortLabel === 'test'">
                        <img *ngIf="country.shortLabel !== 'test'" src="http://www.geonames.org/flags/s/{{country.shortLabel}}.png" class="pr-1"> {{country.label}}
                    </a>
                </div>
            </li>
            <li *ngIf="isAuthenticated && tenants && tenants.length === 1" class="nav-item ml-0">
                <a class="nav-link">
                    <img src="http://www.geonames.org/flags/s/{{selectedTenant.shortLabel}}.png" class="pr-1"> {{selectedTenant.label}}
                </a>
            </li>
            <li *ngIf="isAuthenticated && userName" ngbDropdown placement="bottom-right" class="nav-item" [class.ml-auto]="!tenants || tenants.length === 0">
                <a ngbDropdownToggle class="nav-link pointer" id="navbarDropdownMenuLink" aria-haspopup="true" aria-expanded="false" (click)="$event.preventDefault()">
                    <i class="fas fa-user pr-1"></i> {{ userName }}
                </a>
                <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                    <a class="dropdown-item" [routerLink]="[]" (click)="logout()">
                        <i class="fas fa-sign-out-alt"></i> Cerrar sesión
                    </a>
                </div>
            </li>
            <li *ngIf="!isAuthenticated && !isAuthenticating" class="nav-item ml-auto">
                <a class="nav-link" [routerLink]="[]" (click)="login()">Iniciar sesión</a>
            </li>
        </ul>
    </div>
</nav>

<ng-template #storesModal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">Selección de tienda</h4>
        <button type="button" class="close" aria-label="Close" (click)="d()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <pgs-select-search pgsInputFilter [options]="stores" placeholder="Seleccione una tienda" (selected)="selectedStore = $event"></pgs-select-search>
        <small>Al cambiar de tienda se recargará la pantalla y se perderán los cambios.</small>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="c(false)">Cancelar</button>
        <button type="button" class="btn btn-conversion" id="btnAceptar" [disabled]="!selectedStore" (click)="c(true)">Aceptar</button>
    </div>
</ng-template>
